// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .mat-button:hover .mat-button-focus-overlay {
   opacity: 0.04 !important;
}

::ng-deep .mat-button-focus-overlay {
   background-color: transparent !important;
}

::ng-deep #reject.mat-button.mat-warn .mat-button-focus-overlay, .mat-icon-button.mat-warn .mat-button-focus-overlay, .mat-stroked-button.mat-warn .mat-button-focus-overlay {
   background-color: #f44336 !important;
   opacity: 0.04;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-signature/confirm-removesign-dialog/confirm-removesign-dialog.component.css"],"names":[],"mappings":"AAAA;GACG,wBAAwB;AAC3B;;AAEA;GACG,wCAAwC;AAC3C;;AAEA;GACG,oCAAoC;GACpC,aAAa;AAChB","sourcesContent":["::ng-deep .mat-button:hover .mat-button-focus-overlay {\n   opacity: 0.04 !important;\n}\n\n::ng-deep .mat-button-focus-overlay {\n   background-color: transparent !important;\n}\n\n::ng-deep #reject.mat-button.mat-warn .mat-button-focus-overlay, .mat-icon-button.mat-warn .mat-button-focus-overlay, .mat-stroked-button.mat-warn .mat-button-focus-overlay {\n   background-color: #f44336 !important;\n   opacity: 0.04;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
